import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("mx_access_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

let isRefreshing = false;
let refreshPromise = null;

api.interceptors.response.use(
    (r) => r,
    async (err) => {
        const original = err.config;
        if (err.response?.status === 401 && !original._retry && localStorage.getItem("mx_refresh_token")) {
            original._retry = true;
            try {
                if (!isRefreshing) {
                    isRefreshing = true;
                    refreshPromise = axios.post(`${API_BASE}/auth/refresh`, {
                        refresh_token: localStorage.getItem("mx_refresh_token"),
                    }).finally(() => { isRefreshing = false; });
                }
                const resp = await refreshPromise;
                const newToken = resp.data.access_token;
                localStorage.setItem("mx_access_token", newToken);
                original.headers.Authorization = `Bearer ${newToken}`;
                return api(original);
            } catch (e) {
                localStorage.removeItem("mx_access_token");
                localStorage.removeItem("mx_refresh_token");
                window.location.href = "/login";
            }
        }
        return Promise.reject(err);
    }
);

export default api;
